
export default {
  name: 'YourCertificate',
  data() {
    return {
      activeHotspot: null,
      isMobile: false,
      hotspots: [
        { id: 1, top: '10%', left: '-2.5%' },
        { id: 2, top: '51%', left: '-2.5%' },
        { id: 3, top: '67%', left: '-2.5%' },
        { id: 4, top: '80%', left: '82%' },
        { id: 5, top: '80%', left: '10%' }
      ],
      annotations: [
        {
          id: 1,
          title: 'Issuing Organisation',
          description: "Your certificate is issued by The TEFL Org. The world's most accredited TEFL provider"
        },
        {
          id: 2,
          title: 'Your Name',
          description: 'Your full name will be shown clearly'
        },
        {
          id: 3,
          title: 'Course Title',
          description: 'The name of the TEFL course you have completed'
        },
        {
          id: 4,
          title: 'Official Seal',
          description: 'Each certificate includes a seal of authenticity, recognised globally'
        },
        {
          id: 5,
          title: 'Completion Date and Verification ID',
          description: 'The date you completed the course and your verification ID'
        }
      ]
    }
  },
  computed: {
    getActiveAnnotation() {
      return this.annotations.find(a => a.id === this.activeHotspot) || {}
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    handleHotspotClick(id) {
      // On mobile: toggle tooltip. On desktop: ignore (hover handles it)
      if (!this.isMobile) return
      this.activeHotspot = this.activeHotspot === id ? null : id
    },
    checkMobile() {
      this.isMobile = window.innerWidth < 1024
    }
  }
}
